import { z } from 'zod';

const OIB_REGEX = /^\d{11}$/;
const VAT_REGEX = /^[A-Z]{2}[A-Z0-9]{8,12}$/; 
// primjer: HR12345678901

export const RegisterProviderSchema = z
  .object({
    name: z.string().min( 2, 'Ime je obavezno' ),
    city: z.string().min(2, 'Grad je obavezan'),
    surname: z.string().min(2, 'Prezime je obavezno'),
    email: z.string().email('Neispravan email'),
    country: z.string().min(2),
    providerType: z.enum(['private', 'company'],"Odaberite vrstu račun"),

    phone: z
      .string()
      .min(8, 'Broj mobitela je obavezan')
      .regex(/^\+[1-9]\d{7,14}$/, 'Neispravan format broja (npr. +38595555959)'),

    password: z
      .string()
      .min(8, 'Lozinka mora imati barem 8 znakova')
      .regex(/[0-9]/, 'Lozinka mora sadržavati broj')
      .regex(/[^a-zA-Z0-9]/, 'Lozinka mora sadržavati poseban znak'),

    confirmPassword: z.string(),
signupFlow: z
  .enum(['ticketing'])
  .optional(),
    role: z.string().default('provider').optional(),

    // COMPANY
    companyName: z.string().optional(),
    companyOib: z.string().optional(),
    companyAddress: z.string().optional(),
    companyCountry: z.string().optional(),
        companyCity: z.string().optional(),
companyPostalCode:z.string().optional(),
    isCompanyInVat: z.boolean().default(false),
    taxId: z.string().optional().nullable(),

    terms: z.literal(true, {
      message: 'Morate prihvatiti uvjete korištenja.',
    }),
  })

  // password check
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Lozinke se ne podudaraju',
    path: ['confirmPassword'],
  })

  // company required fields
  .refine(
    (data) => {
      if (data.providerType === 'company') {
        return (
          data.companyName &&
          data.companyOib &&
          data.companyAddress &&
          data.companyCountry && data.companyPostalCode &&data.companyPostalCode
        );
      }
      return true;
    },
    {
      message: 'Sva polja za tvrtku su obavezna',
      path: ['companyName'],
    }
  )

  // OIB validation (HR)
  .refine(
    (data) => {
      if (data.providerType === 'company' && data.companyCountry === 'HR') {
        return OIB_REGEX.test(data.companyOib || '');
      }
      return true;
    },
    {
      message: 'OIB mora imati 11 znamenki',
      path: ['companyOib'],
    }
  )

  // VAT required only if isCompanyInVat === true
  .refine(
    (data) => {
      if (
        data.providerType === 'company' &&
        data.isCompanyInVat === true
      ) {
        return !!data.taxId && VAT_REGEX.test(data.taxId);
      }
      return true;
    },
    {
      message: 'VAT ID je obavezan i mora biti ispravan (npr. HR12345678901)',
      path: ['taxId'],
    }
  );

export type RegisterProviderInput = z.infer<
  typeof RegisterProviderSchema
>;
